export const styles = {
    textNormal: {
        font: "inherit",
        fontSize: 14,
        color: "#495057",
    },
    selfCenter: {
        alignSelf: 'center'
    }
};